import { useEffect, useRef, useState, memo } from 'react';
import { eventBusExample } from '@/sub-luca-plugin/utils/class-example';
import { SuccessOfToastSvg, WarningOfToastSvg } from '@/sub-luca-plugin/compatible-components/svg-icons';
import { INoticeData } from '@/sub-luca-plugin/types';
import './index.scss';

interface IProps {
    subscribeName?: 'QaToast' | 'QaDetailToast';
}

const Toast = ({ subscribeName = 'QaToast' }: IProps) => {
    const timer = useRef<ReturnType<typeof setTimeout>>();
    const [toastInfo, setToastInfo] = useState<{ content?: string; iconType?: 'warning' | 'success' }>({});

    useEffect(() => {
        eventBusExample.subscribe(subscribeName, ({ type, params = {} }: INoticeData) => {
            const { message, iconType } = params;
            switch (type) {
                case 'show':
                    setToastInfo({ content: message || '', iconType: iconType || 'warning' });
                    clearTimeout(timer.current);
                    timer.current = setTimeout(() => setToastInfo({}), 2000);
                    break;
                default:
                    setToastInfo({});
                    break;
            }
        });
    }, []);

    return (
        <div className="toast-container" style={{ display: toastInfo.content ? 'flex' : 'none' }}>
            <div className="toast">
                {toastInfo.iconType === 'warning' && <WarningOfToastSvg />}
                {toastInfo.iconType === 'success' && <SuccessOfToastSvg />}
                <div className="toast__message">{toastInfo.content}</div>
            </div>
        </div>
    );
};

export default memo(Toast);
